import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { createChart as Ls } from '../../node_modules/lightweight-charts/dist/lightweight-charts.esm.production.js';
import React__default from 'react';
var Chart = React__default.memo(function (_a) {
  var barSeries = _a.barSeries,
    candlestickSeries = _a.candlestickSeries,
    areaSeries = _a.areaSeries,
    lineSeries = _a.lineSeries,
    histogramSeries = _a.histogramSeries,
    onCrosshairMove = _a.onCrosshairMove,
    onClick = _a.onClick,
    rest = __rest(_a, ["barSeries", "candlestickSeries", "areaSeries", "lineSeries", "histogramSeries", "onCrosshairMove", "onClick"]);
  var containerRef = React__default.useRef(null);
  var chartRef = React__default.useRef();
  var barSeriesRef = React__default.useRef();
  var candlestickSeriesRef = React__default.useRef();
  var areaSeriesRef = React__default.useRef();
  var lineSeriesRef = React__default.useRef();
  var histogramSeriesRef = React__default.useRef();
  var crosshairMoveCallback = React__default.useRef(onCrosshairMove);
  var clickCallback = React__default.useRef(onClick);
  React__default.useEffect(function () {
    if (containerRef.current) {
      chartRef.current = Ls(containerRef.current);
      chartRef.current.subscribeCrosshairMove(function (param) {
        window.requestAnimationFrame(function () {
          var _a;
          (_a = crosshairMoveCallback.current) === null || _a === void 0 ? void 0 : _a.call(crosshairMoveCallback, param);
        });
      });
      chartRef.current.subscribeClick(function (param) {
        window.requestAnimationFrame(function () {
          var _a;
          (_a = clickCallback.current) === null || _a === void 0 ? void 0 : _a.call(clickCallback, param);
        });
      });
    }
  }, [chartRef, containerRef]);
  React__default.useEffect(function () {
    var _a, _b;
    (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.applyOptions(__assign(__assign({}, rest.options), {
      layout: __assign({}, (_b = rest.options) === null || _b === void 0 ? void 0 : _b.layout)
    }));
  }, [rest]);
  React__default.useEffect(function () {
    var _a, _b, _c;
    if (!barSeriesRef.current) {
      barSeriesRef.current = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.addBarSeries();
    }
    if (barSeriesRef.current) {
      if (barSeries) {
        barSeriesRef.current.setData(barSeries.data);
        if (barSeries.options) {
          barSeriesRef.current.applyOptions(barSeries.options);
        }
      } else {
        (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.removeSeries(barSeriesRef.current);
        barSeriesRef.current = undefined;
      }
    }
    (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.timeScale().fitContent();
  }, [barSeries]);
  React__default.useEffect(function () {
    var _a, _b, _c;
    if (!histogramSeriesRef.current) {
      histogramSeriesRef.current = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.addHistogramSeries();
    }
    if (histogramSeriesRef.current) {
      if (histogramSeries) {
        histogramSeriesRef.current.setData(histogramSeries.data);
        if (histogramSeries.options) {
          histogramSeriesRef.current.applyOptions(histogramSeries.options);
        }
      } else {
        (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.removeSeries(histogramSeriesRef.current);
        histogramSeriesRef.current = undefined;
      }
    }
    (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.timeScale().fitContent();
  }, [histogramSeries]);
  React__default.useEffect(function () {
    var _a, _b, _c;
    if (!candlestickSeriesRef.current) {
      candlestickSeriesRef.current = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.addCandlestickSeries();
    }
    if (candlestickSeriesRef.current) {
      if (candlestickSeries) {
        candlestickSeriesRef.current.setData(candlestickSeries.data);
        if (candlestickSeries.options) {
          candlestickSeriesRef.current.applyOptions(candlestickSeries.options);
        }
      } else {
        (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.removeSeries(candlestickSeriesRef.current);
        candlestickSeriesRef.current = undefined;
      }
    }
    (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.timeScale().fitContent();
  }, [candlestickSeries]);
  React__default.useEffect(function () {
    var _a, _b, _c;
    if (!areaSeriesRef.current) {
      areaSeriesRef.current = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.addAreaSeries();
    }
    if (areaSeriesRef.current) {
      if (areaSeries) {
        areaSeriesRef.current.setData(areaSeries.data);
        if (areaSeries.options) {
          areaSeriesRef.current.applyOptions(areaSeries.options);
        }
      } else {
        (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.removeSeries(areaSeriesRef.current);
        areaSeriesRef.current = undefined;
      }
    }
    (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.timeScale().fitContent();
  }, [areaSeries]);
  React__default.useEffect(function () {
    var _a, _b, _c;
    if (!lineSeriesRef.current) {
      lineSeriesRef.current = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.addLineSeries();
    }
    if (lineSeriesRef.current) {
      if (lineSeries) {
        lineSeriesRef.current.setData(lineSeries.data);
        if (lineSeries.options) {
          lineSeriesRef.current.applyOptions(lineSeries.options);
        }
      } else {
        (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.removeSeries(lineSeriesRef.current);
        lineSeriesRef.current = undefined;
      }
    }
    (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.timeScale().fitContent();
  }, [lineSeries]);
  React__default.useEffect(function () {
    crosshairMoveCallback.current = onCrosshairMove;
  }, [onCrosshairMove]);
  React__default.useEffect(function () {
    clickCallback.current = onClick;
  }, [onClick]);
  return React__default.createElement("div", {
    ref: containerRef
  });
});
export { Chart };